import styled from "styled-components";
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 2em;
    font-size: 1rem;
    position: relative;

    &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 350px;
        left: 0;
        top: 0;
        background-image: radial-gradient(50% 80% at top, rgba(0,0,0,0.5), transparent);
        background-repeat: no-repeat;
        background-position: center top;
    }
`;

const PCBox = DefaultBox;

const MobileBox = styled(DefaultBox)`
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        padding: 0.25em;
    }
    &:before {
      display:none;
    }
`;

export const LiveCasinoGridDefaultBox = styledByDevice(PCBox, MobileBox);